import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Dropzone from 'dropzone';
import history from '../../utils/history';
import LocalDB from '../../utils/localDB';
import { uploadDocuments, updateQuote } from '../../actions/policy';
import { translations } from '../../i18n/translations';

class BuyerDetails extends Component {
  constructor(props) {
    super(props);

    this.state = LocalDB.fetch('mci_form');
    this.uploadSupportingDocuments = this.uploadSupportingDocuments.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    this.setState({
      commercial_invoice: null,
      idf: null,
      packing_list: null,
      pvcoc: null,
      bill_of_lading: null,
      error: false,
      errorMessage: null
    });
  }

  componentWillUnmount() {
    LocalDB.insert('mci_form', this.state);
  }

  componentDidMount() {
    const MCIDropzone = new Dropzone('div#mci-dropzone', {
      url: '/'
    });

    MCIDropzone.on('addedfile', file => {
      this.setState({
        commercial_invoice: file
      });
    });
  }

  onChange = e => {
    const { name, files } = e.target;
    this.setState({
      [name]: files[0]
    });
  };

  uploadSupportingDocuments = e => {
    e.preventDefault();

    if (this.state.commercial_invoice === null) {
      this.setState({
        error: true,
        errorMessage:
          'Please make sure you have selected at least the commercial invoice'
      });
      return;
    }

    const uploads = {
      commercial_invoice: this.state.commercial_invoice,
      bill_of_lading: this.state.bill_of_lading,
      pvcoc: this.state.pvcoc,
      packing_list: this.state.packing_list,
      idf: this.state.idf,
      quote: this.props.policy ? this.props.policy.quote.id : null
    };

    // this.props.updateQuote(quote);
    this.props.uploadDocuments(uploads).then(() => {
      const { uploaded } = this.props.policy;
      if (uploaded) {
        //navigate to payments page
        history.push('/buy/payment');
      }
    });
  };

  render() {
    return (
      <div className="clearfix col-sm-12">
        <form className="form-horizontal">
          <div className="messages">
            {this.state.error ? (
              <div className="alert alert-danger" role="alert">
                {this.state.errorMessage}
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="row">
            <div className="col-sm-8">
              <div className="form-group">
                <label className="control-label col-sm-5">
                  {translations.commercial_invoice}:
                </label>
                <div className="col-sm-7">
                  <div className="mci-dropzone" id="mci-dropzone">
                    {translations.dropzone_hint}
                  </div>
                  {false ? (
                    <input
                      name="commercial_invoice"
                      type="file"
                      onChange={this.uploadFile}
                    />
                  ) : null}
                </div>
              </div>

              <div className="form-group">
                <label className="control-label col-sm-5">
                  Bill of Lading:
                </label>
                <div className="col-sm-7">
                  <input
                    type="file"
                    name="bill_of_lading"
                    onChange={this.onChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="control-label col-sm-5">
                  Import Declaration Form:
                </label>
                <div className="col-sm-7">
                  <input
                    type="file"
                    name="idf"
                    className="text-uppercase"
                    onChange={this.onChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="control-label col-sm-5">Packing List:</label>
                <div className="col-sm-7">
                  <input
                    type="file"
                    name="packing_list"
                    onChange={this.onChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="control-label col-sm-5">PVCOC:</label>
                <div className="col-sm-7">
                  <input type="file" name="pvcoc" onChange={this.onChange} />
                </div>
              </div>
            </div>
          </div>
        </form>
        <div className="clearfix">
          <hr />
          <span
            className="btn btn-warning"
            onClick={() => {
              window.history.back();
            }}
          >
            <span className="glyphicon glyphicon-menu-left" />{' '}
            {translations.btn_back}
          </span>
          <button
            className="btn btn-success pull-right"
            onClick={this.uploadSupportingDocuments}
          >
            {translations.btn_next}{' '}
            <span className="glyphicon glyphicon-menu-right" />
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  policy: state.policy,
  user: state.user
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ uploadDocuments, updateQuote }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyerDetails);



// WEBPACK FOOTER //
// ./src/pages/buy/BuyerDetails.jsx